import { useState } from 'react';
import { faqItems } from '@/mocks/homeContent';

export default function FAQSection() {
  const [openIdx, setOpenIdx] = useState<number | null>(null);

  return (
    <section className="py-16 md:py-24 px-4 md:px-10 bg-background-50">
      <div className="max-w-3xl mx-auto">
        <p className="text-xs md:text-sm text-foreground-500 font-medium uppercase tracking-wider mb-2 text-center">
          Frequently Asked Questions
        </p>
        <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 mb-12 leading-tight text-center">
          Got Questions?<br />We Have Answers
        </h2>

        <div className="space-y-3">
          {faqItems.map((item, idx) => (
            <div
              key={idx}
              className="bg-background-100 rounded-2xl border border-background-200/60 overflow-hidden"
            >
              <button
                onClick={() => setOpenIdx(openIdx === idx ? null : idx)}
                className="w-full flex items-center justify-between p-5 md:p-6 text-left cursor-pointer"
              >
                <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-900 pr-4">
                  {item.question}
                </h3>
                <span className={`flex-shrink-0 w-8 h-8 rounded-full bg-background-200 flex items-center justify-center transition-transform duration-300 ${openIdx === idx ? 'rotate-45' : ''}`}>
                  <i className="ri-add-line text-foreground-600"></i>
                </span>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIdx === idx ? 'max-h-96 pb-5 md:pb-6' : 'max-h-0'
                }`}
              >
                <p className="px-5 md:px-6 text-foreground-600 text-sm md:text-base leading-relaxed">
                  {item.answer}
                </p>
              </div>
            </div>
          ))}
        </div>

        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              '@context': 'https://schema.org',
              '@type': 'FAQPage',
              mainEntity: faqItems.map((item) => ({
                '@type': 'Question',
                name: item.question,
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: item.answer,
                },
              })),
            }),
          }}
        />
      </div>
    </section>
  );
}